import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../customerFullInfoState/customerFullInfoContext';
import style from './EditBtn.module.scss';

const EditBtn: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<Link to={`/clients/customers/edit?customerID=${customerForFullInfo?.id}`}>
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="form" translationKey="editCustomerButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default EditBtn;
